import api from './axios';

// ── Tab definitions (static list of all tabs) ──
export const getTabDefinitions = async () => {
  const response = await api.get('/api/tab-permissions/tabs');
  return response.data;
};

// ── Role permission matrix ──
export const getRolePermissions = async () => {
  const response = await api.get('/api/tab-permissions/roles');
  return response.data;
};

export const saveRolePermissions = async (permissions) => {
  const response = await api.put('/api/tab-permissions/roles', { permissions });
  return response.data;
};

// ── User-level overrides ──
export const getUserPermissions = async (userId) => {
  const response = await api.get(`/api/tab-permissions/users/${userId}`);
  return response.data;
};

export const saveUserPermissions = async (userId, permissions) => {
  const response = await api.put('/api/tab-permissions/users', { userId, permissions });
  return response.data;
};

export const clearUserPermissions = async (userId) => {
  const response = await api.delete(`/api/tab-permissions/users/${userId}`);
  return response.data;
};

// ── Current user's resolved tabs ──
export const getMyTabs = async () => {
  const response = await api.get('/api/tab-permissions/my-tabs');
  return response.data;
};
